export default __webpack_public_path__ + "static/media/nubCon2.918c2413.png";